export const getPercent = (price: number, total: number): string => {
  if (!total || !price) return '0';
  const v = (100 * price) / total;
  const d = v - Number(v.toFixed(0));
  if ((d < 0.1 && d > 0) || d === 0) return v.toFixed(0);
  else if (v < 10) return v.toFixed(2);
  else return v.toFixed(1);
};

/**
 * Formats a raw count value (scaled by 1e6) into a percentage string
 * @param rawCount - The raw count value from backend (scaled by 1,000,000)
 * @param options - Formatting options
 * @param options.includePercent - Whether to include '%' symbol (default: false)
 * @param options.truncate - Whether to truncate instead of round (default: false)
 * @param options.handleSmallValues - Whether to handle values < 0.001 specially (default: true)
 * @returns Formatted percentage string
 */
export const formatPercent = (
  rawCount: number,
  options: {
    includePercent?: boolean;
    truncate?: boolean;
    handleSmallValues?: boolean;
  } = {}
): string => {
  const { includePercent = false, truncate = false, handleSmallValues = true } = options;

  const percent = rawCount / 1_000_000; // backend scale 1e6

  // Handle very small values
  if (handleSmallValues && percent > 0 && percent < 0.001) {
    return includePercent ? '<0.001%' : '<0.001';
  }

  // Always use 3 decimal places for consistency
  const digits = 3;
  const factor = Math.pow(10, digits);

  let result: number;
  if (truncate) {
    result = Math.floor(percent * factor) / factor;
  } else {
    result = percent;
  }

  const formatted = result.toFixed(digits);
  return includePercent ? `${formatted}%` : formatted;
};
